import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IFoThucDonInsertItemRequest } from '../../../models/request/thuc-don/IFoThucDonInsertItemRequest';
import { IFoThucDonItemRequest } from '../../../models/request/thuc-don/IFoThucDonItemRequest';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IFoThucDon } from '../../../models/response/thuc-don/IFoThucDon';
import { eFoThucDonActionTypeIds, IFoThucDonActionTypes } from '../../action-types/thuc-don/IFoThucDonActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* foThucDonSaga(): any {
    yield takeLatest(eFoThucDonActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eFoThucDonActionTypeIds.LOAD_COSO_START, selectByCoSoWorker)
    yield takeLatest(eFoThucDonActionTypeIds.LOAD_THEO_NGAY_START, selectByDayWorker)
    yield takeEvery(eFoThucDonActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eFoThucDonActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.thucDon.select_all)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.thucDon.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.thucDon.LOAD_ERROR(res.message ?? "Error"))
    }
}
function* selectByCoSoWorker(action: IFoThucDonActionTypes): any {
    const payload: number = action.payload as number;

    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.thucDon.select_by_coso, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.thucDon.LOAD_COSO_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.thucDon.LOAD_COSO_ERROR(res.message ?? "Error"))
    }
}
function* selectByDayWorker(action: IFoThucDonActionTypes): any {
    const payload: IFoThucDonItemRequest = action.payload as IFoThucDonItemRequest;

    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.thucDon.select_detail_daybyday, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.thucDon.LOAD_THEO_NGAY_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.thucDon.LOAD_THEO_NGAY_ERROR(res.message ?? "Error"))
    }
}
function* saveWorker(action: IFoThucDonActionTypes): any {
    const payload: IFoThucDon = action.payload as IFoThucDon;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.thucDonWrapper.thucDon.update, payload)
    } else {
        res = yield call(apiWrapper.thucDonWrapper.thucDon.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.thucDonWrapper.thucDon.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.thucDon.SAVE_ERROR(res.message ?? "Error"))
    }
}
function* insertMultipleWorker(action: IFoThucDonActionTypes): any {
    const payload: IFoThucDonInsertItemRequest = action.payload as IFoThucDonInsertItemRequest;
    let res: IBaseResponeModel;
    res = yield call(apiWrapper.thucDonWrapper.thucDon.insert_multiple, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.thucDon.INSERT_MULTIPLE_SUCCESS(res.data))
    } else {
        yield put(actions.thucDonWrapper.thucDon.INSERT_MULTIPLE_ERROR(res.message ?? "Error"))
    }
}
function* deleteWorker(action: IFoThucDonActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.thucDonWrapper.thucDon.delete, payload)
    if (res.is_success) {
        yield put(actions.thucDonWrapper.thucDon.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.thucDonWrapper.thucDon.DELETE_ERROR(res.message ?? "Error"))
    }
}